import { useState } from "react";
import LoginForm from "./LoginForm";
import RegisterForm from "./RegisterForm";

export default function LoginPage({ onLogin, t, isDark, toggleTheme }) {
    const [authMode, setAuthMode] = useState("login");

    return (
        <div style={{ minHeight: "100vh", background: t.bg, display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'Inter', sans-serif" }}>
            <div style={{ position: "absolute", top: 20, right: 20 }}>
                <button onClick={toggleTheme} style={{ background: t.surface, border: `1px solid ${t.border}`, color: t.text, borderRadius: 20, padding: "6px 14px", cursor: "pointer", fontSize: 14 }}>
                    {isDark ? "☀️ 淺色" : "🌙 深色"}
                </button>
            </div>
            <div style={{ background: t.surface, borderRadius: 16, padding: 36, width: 440, border: `1px solid ${t.border}`, boxShadow: "0 20px 60px #00000033" }}>
                <div style={{ textAlign: "center", marginBottom: 24 }}>
                    <span style={{ fontSize: 44 }}>👁️</span>
                    <h1 style={{ fontSize: 26, fontWeight: 700, color: t.text, margin: "6px 0 2px" }}>
                        <span style={{ color: t.text }}>A-</span><span style={{ color: t.accent }}>EYE</span>
                    </h1>
                    <p style={{ color: t.textFaint, fontSize: 13, margin: 0 }}>Retail Management System</p>
                </div>
                <div style={{ display: "flex", background: t.inputBg, borderRadius: 10, padding: 4, marginBottom: 24, border: `1px solid ${t.border}` }}>
                    {[{ key: "login", label: "🔑 登入" }, { key: "register", label: "📝 註冊" }].map((tab) => (
                        <button key={tab.key} onClick={() => setAuthMode(tab.key)}
                            style={{ flex: 1, padding: "8px", border: "none", borderRadius: 8, cursor: "pointer", fontSize: 13, fontWeight: 600, transition: "all 0.2s", background: authMode === tab.key ? t.surface : "transparent", color: authMode === tab.key ? t.text : t.textFaint, boxShadow: authMode === tab.key ? "0 1px 4px #00000022" : "none" }}>
                            {tab.label}
                        </button>
                    ))}
                </div>
                {authMode === "login"
                    ? <LoginForm onLogin={onLogin} t={t} />
                    : <RegisterForm onDone={() => setAuthMode("login")} t={t} />}
            </div>
        </div>
    );
}